import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import SettingsRoundedOutlinedIcon from '@mui/icons-material/SettingsRounded';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { useAuth } from '../auth/AuthProvider';
import useIsAdmin from '../../hooks/useIsAdmin';

const mainListItems = [
  {
    text: 'Dashboard',
    icon: <SpaceDashboardOutlinedIcon sx={{ color: 'primary.main' }} />,
    path: '/app',
  },
];

const navigateToNewTab = (path: any) => {
  const newTab = window.open(path, '_blank');
  newTab?.focus();
};

const secondaryListItems = [
  {
    text: 'Admin',
    icon: <AdminPanelSettingsOutlinedIcon sx={{ color: 'primary.main' }} />,
    path: '/app/admin',
    isAdmin: true,
  },
  {
    text: 'Account',
    icon: <SettingsRoundedOutlinedIcon sx={{ color: 'primary.main' }} />,
    path: '/app/settings',
  },
  {
    id: 'feedback',
    text: 'Share feedback',
    icon: <HelpOutlineOutlinedIcon sx={{ color: 'primary.main' }} />,
    path: 'https://forms.gle/26QZ5CdX8s7Crb5z6',
    nextPage: true,
  },
];

export default function MenuContent() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { isAdmin } = useIsAdmin(currentUser);

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={index === 0}
              onClick={() => {
                setSelectedIndex(0);
                navigate(item.path);
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box>
        <Divider />
        <List dense>
          {secondaryListItems
            .filter((item) => !item.isAdmin || isAdmin)
            .map((item, index) => (
              <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                  selected={selectedIndex === index + 1}
                  onClick={() => {
                    if (item.nextPage) {
                      return navigateToNewTab(item.path);
                    }
                    return navigate(item.path);
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          {
            <ListItem sx={{ display: 'block' }} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <CreateNewFolderOutlinedIcon sx={{ color: 'primary.main' }} />
                </ListItemIcon>
                <a
                  data-canny-link
                  href="https://onetree.canny.io"
                  target="_blank"
                  rel="noreferrer"
                >
                  Feature requests
                </a>
              </ListItemButton>
            </ListItem>
          }
        </List>
      </Box>
    </Stack>
  );
}
